/**
 * DONATION SETTINGS
 * 
 * Admin component for managing donation settings.
 * 
 * @module Donations/Components/Settings
 */

import React, { useState } from 'react';
import { Settings, Tag, CreditCard, ArrowLeft } from 'lucide-react';
import { CategoryManager } from './CategoryManager';
import { PaymentMethodManager } from './PaymentMethodManager';

interface DonationSettingsProps {
    onBack?: () => void;
}

export const DonationSettings: React.FC<DonationSettingsProps> = ({ onBack }) => {
    const [activeTab, setActiveTab] = useState<'categories' | 'payment-methods'>('categories');

    return (
        <div className="donation-settings">
            <div className="settings-header">
                <div className="header-left">
                    {onBack && (
                        <button className="back-btn" onClick={onBack}>
                            <ArrowLeft size={18} />
                        </button>
                    )}
                    <h2>
                        <Settings size={20} />
                        Donation Settings
                    </h2>
                </div>
                <p>Configure categories and payment methods for donations.</p>
            </div>

            <div className="settings-tabs">
                <button
                    className={`settings-tab ${activeTab === 'categories' ? 'active' : ''}`}
                    onClick={() => setActiveTab('categories')}
                >
                    <Tag size={16} />
                    Categories
                </button>
                <button
                    className={`settings-tab ${activeTab === 'payment-methods' ? 'active' : ''}`}
                    onClick={() => setActiveTab('payment-methods')}
                >
                    <CreditCard size={16} />
                    Payment Methods
                </button>
            </div>

            <div className="settings-content">
                {activeTab === 'categories' && <CategoryManager />}
                {activeTab === 'payment-methods' && <PaymentMethodManager />}
            </div>
        </div>
    );
};

export default DonationSettings;
